import { Link } from "react-router-dom";
import { Smartphone } from "lucide-react";
import { Logo } from "../Logo";
import { ERP_URL } from "./PublicNav";

const sectionHref = (id) => (window.location.pathname === "/" ? `#${id}` : `/#${id}`);

export const PublicFooter = () => (
  <footer data-testid="site-footer" className="border-t border-slate-100 bg-white">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-5 py-14 sm:grid-cols-2 sm:px-8 lg:grid-cols-4">
      <div>
        <Logo size={36} />
        <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-500">
          The society management ERP for managers, committees and residents — tenants, collections,
          notices and requests in one calm platform.
        </p>
      </div>
      <div>
        <p className="mb-4 font-mono text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-400">Product</p>
        <ul className="space-y-2.5 text-sm">
          <li><a href={sectionHref("features")} data-testid="footer-link-features" className="text-slate-600 hover:text-blue-600">Features</a></li>
          <li><a href={sectionHref("pricing")} data-testid="footer-link-pricing" className="text-slate-600 hover:text-blue-600">Pricing</a></li>
          <li><a href={ERP_URL} data-testid="footer-link-login" className="text-slate-600 hover:text-blue-600">ERP Login</a></li>
          <li>
            <span data-testid="footer-download-app" className="inline-flex items-center gap-2 text-slate-400">
              <Smartphone size={14} /> Android App
              <span className="rounded-full bg-amber-50 px-2 py-0.5 font-mono text-[9px] font-semibold uppercase tracking-wider text-amber-600">Coming soon</span>
            </span>
          </li>
        </ul>
      </div>
      <div>
        <p className="mb-4 font-mono text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-400">Company</p>
        <ul className="space-y-2.5 text-sm">
          <li><a href={sectionHref("about")} data-testid="footer-link-about" className="text-slate-600 hover:text-blue-600">About Us</a></li>
          <li><a href={sectionHref("contact")} data-testid="footer-link-contact" className="text-slate-600 hover:text-blue-600">Contact Us</a></li>
          <li><a href={sectionHref("contact")} data-testid="footer-link-demo" className="text-slate-600 hover:text-blue-600">Request Demo</a></li>
          <li><a href="mailto:support@synqsmc.com" data-testid="footer-link-support" className="text-slate-600 hover:text-blue-600">Support</a></li>
        </ul>
      </div>
      <div>
        <p className="mb-4 font-mono text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-400">Legal</p>
        <ul className="space-y-2.5 text-sm">
          <li><Link to="/privacy" data-testid="footer-link-privacy" className="text-slate-600 hover:text-blue-600">Privacy Policy</Link></li>
          <li><Link to="/terms" data-testid="footer-link-terms" className="text-slate-600 hover:text-blue-600">Terms &amp; Conditions</Link></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-slate-100 py-6">
      <p className="text-center text-sm text-slate-400" data-testid="footer-copyright">
        © 2026 SynqSMC. All rights reserved.
      </p>
    </div>
  </footer>
);
